import request from "../utils/request";

export function getSites(perPage = 25, page = 1, extendedMeta, cache = false) {
    return request.get("sites/pagination", {
        params: {
            pageCount: page,
            perPage: perPage,
            extendedMeta,
            cache,
        },
        timeout: 60000,
    });
}

export function lookupSites(pagination, sorting, search, filters, startDate, endDate, planIds) {
    return request.post(
        "sites/lookup?extendedMeta=true",
        {
            pagination,
            sorting,
            search,
            filters,
            startDate,
            endDate,
            planIds,
        },

        { timeout: 60000 }
    );
}

export function getSite(id) {
    return request.get(`sites/site/${id}`);
}

export function createSite(data) {
    return request.post("sites/", data);
}

export function deleteSite(siteId) {
    return request.delete(`sites/${siteId}`, {
        timeout: 1000 * 60 * 5,
    });
}

export function updateSite(id, data) {
    return request.put(`sites/${id}`, data);
}

export function getSiteBySiteAddress(siteAddress) {
    return request.get(`sites/search/${siteAddress}`);
}

export function getSiteDetail(siteAddress) {
    return request.get(`sites/detail/${siteAddress}`);
}

export function clean() {
    return request.get(`sites/clean`, { timeout: 1000 * 60 });
}

export function runSwitchToV2() {
    return request.patch(`settings/switch-to-v2`, { timeout: 1000 * 60 });
}

export function checkIntegrationStatus(website) {
    return request.post(`public/sites/check-integration-status`, { website }).then((res) => res.data);
}

export function updateSiteSingleKey(siteId, key, value) {
    return request.post(`sites/${siteId}/update-single-key`, { siteId, key, value });
}

export function getSiteCurrentPlans() {
    return request.get(`sites/current-plan`).then((res) => res.data);
}

export function getSiteCurrentPlansById(siteId) {
    return request.get(`sites/${siteId}/current-plan`).then((res) => res.data);
}

export function getSitePlans() {
    return request.get(`plans`).then((res) => res.data);
}

export function getDefaultPlans() {
    return request.get(`plans/default-plans`).then((res) => res.data);
}

export function getSitePlansById(siteId) {
    return request.get(`plans/${siteId}`).then((res) => res.data);
}

export function createPlan(data) {
    return request.post(`plans`, data).then((res) => res.data);
}

export function deletePlan(id) {
    return request.delete(`plans/${id}`).then((res) => res.data);
}

export function updatePlan(id, data) {
    return request.patch(`plans/${id}`, data).then((res) => res.data);
}

export function skipTrialDays() {
    return request.post(`sites/skip-trial`).then((res) => res.data);
}

export function getBalance() {
    return request.get(`sites/wallet`).then((res) => res.data);
}

export function getBalanceById(siteId) {
    return request.get(`sites/${siteId}/wallet`).then((res) => res.data);
}

export function setBalanceById({ siteId, walletType, amount }) {
    return request.put(`sites/${siteId}/wallet/${walletType}`, { amount }).then((res) => res.data);
}

export function getBalanceActivities(page, perPage, type, channelId, startDate, endDate) {
    const params = { page, perPage, startDate, endDate };
    if (type) params["type"] = type;
    if (channelId) params["channelId"] = channelId;
    return request.get(`sites/wallet/activities`, { params }).then((res) => res.data);
}

export function depositBalance({ walletType, amount }) {
    return request.post(`sites/wallet/${walletType}`, { amount }).then((res) => res.data);
}

export function getAllPlans() {
    return request.get(`plans/get-all`).then((res) => res.data);
}

export function getSiteFeatures(siteId) {
    return request.get(siteId ? `sites/${siteId}/features` : `sites/features`).then((res) => res.data);
}

export function getConversationStatistics(startDate, endDate) {
    return request.get("/sites/conversation-usages", {
        params: {
            startDate,
            endDate,
        },
    });
}
